import { Routes, Route } from "react-router-dom";
import VehicleRoute from "./VehicleRoute";
import VehicleDetails from "./VehicleDetails";

function App() {
  return (
    <Routes>
      <Route path="/" element={<VehicleRoute />} />
      <Route path="/vehicle/:driverId" element={<VehicleDetails />} />
    </Routes>
  );
}

export default App;